function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.999512 1.00293L17.0003 17.0037",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1817 7.06796V3.18412C11.1823 2.64303 10.9817 2.12103 10.6191 1.71947C10.2564 1.31791 9.75744 1.06543 9.21908 1.01105C8.68072 0.956672 8.14136 1.10427 7.70571 1.42519C7.27005 1.74611 6.96919 2.21746 6.86151 2.74774M6.81787 6.82067V9.0026C6.81825 9.43386 6.94642 9.85534 7.1862 10.2138C7.42598 10.5723 7.76661 10.8516 8.16507 11.0166C8.56353 11.1816 9.00194 11.2248 9.42494 11.1408C9.84794 11.0568 10.2366 10.8493 10.5417 10.5445L6.81787 6.82067Z",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6365 12.6027C11.9265 13.3274 11.0162 13.8234 10.0223 14.0272C9.02842 14.2309 7.99633 14.1331 7.05844 13.7462C6.12055 13.3593 5.31963 12.701 4.75845 11.8558C4.19726 11.0106 3.90141 10.017 3.90883 9.00247V7.54785M14.0912 7.54785V9.00247C14.0909 9.30244 14.0641 9.6018 14.0112 9.89706",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9 14.0938V17.003",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.09082 17.0029H11.9093",
  fill: "none",
  stroke: "inherit",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgAudioOff = function SvgAudioOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAudioOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/audio-off.46c1002f.svg";
export { ForwardRef as ReactComponent };